module.exports = __webpack_public_path__ + "img/shi-logo.7657bd55.png";